import Api from '@/apis/businessApi'
import Store from '@/store'
import i18n from '@/i18n'

export default {
  async getReseller () {
    return Api()
      .get('/v1/resellerProfile')
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.ResellerProfile.Messages.GetResellerErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async updateReseller (reseller) {
    var updatedReseller = {
      uid: reseller.uid,
      name: reseller.name,
      vatNumber: reseller.vatNumber,
      houseNumber: reseller.houseNumber,
      address: reseller.address,
      postalCode: reseller.postalCode,
      city: reseller.city,
      countryCode: reseller.countryCode,
      type: reseller.type,
      vendorIds: reseller.vendorIds,
      emailAddress: reseller.emailAddress,
      contactPhone: reseller.contactPhone,
      contactName: reseller.contactName,
    }
    return Api()
      .put('/v1/resellerProfile', updatedReseller)
      .then(function (response) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.ResellerProfile.Messages.UpdateResellerSuccessMessage', [updatedReseller.name]),
          color: 'success',
        })
        return { success: true, value: updatedReseller }
      })
      .catch(function (error) {
        if (error.response.status === 400) {
          return { success: false, badRequestReasons: error.response.data }
        }
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.ResellerProfile.Messages.UpdateResellerErrorMessage', [updatedReseller.name]),
          color: 'error',
        })
        console.log(error)
        return { success: false }
      })
  },
}
